import { useContext } from 'react';
import { PostsContext } from '@shapeable/ui';

export const useHowToPosts = () => useContext(PostsContext).filter(post => post?.type?.slug === 'how-to-guide');